<template>
    <div class="container">
        <div class="navigation-wrapper">
            <div class="row">
                <div class="col-12">
                    <router-link to="/">
                        <img class="img img-logo" src="/_resources/themes/bellstores/javascript/loyalty-program/src/assets/images/logo-bell-buddy-rewards.png" alt="Bell Buddy Rewards Logo"/>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <p>
                    To reset your password, enter your email address associated with your loyalty account below.
                    Please remember to check your spam/junk folder in your email.
                </p>
            </div>
        </div>

        <div v-for="error in errorMessages" :key="error" class="alert alert-danger">
            {{ error }}
        </div>

        <div v-if="submitted" class="alert alert-success">
            If an account exists with that email, a password reset link has been sent. Redirecting to login...
        </div>

        <form @submit.prevent="onSubmit" v-if="!submitted">
            <div class="action-container">
                <div class="row">
                    <div class="col-sm-12">
                        <input type="email" required name="userId" class="form-control" v-model.trim="userId" placeholder="Email Address" />
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-sm-12">
                        <button type="submit" class="btn btn-primary btn-bellstores" :disabled="!isValid">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'

export default {
    name: 'ForgotPassword',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            userId: '',
            errorMessages: [],
            submitted: false
        }
    },
    computed: {
        isValid () {
            return this.userId !== ''
        }
    },
    methods: {
        async onSubmit () {
            this.errorMessages = []

            try {
                await this.apiService.auth()
                const response = await this.apiService.forgotPassword(this.userId)

                if (!(response instanceof APIResponseError || response instanceof APIRequestError)) {
                    this.submitted = true

                    setTimeout(() => {
                        this.$router.replace('/login')
                    }, 5000)
                } else {
                    this.errorMessages.push('Something went wrong. Please try again later.')
                }
            } catch (err) {
                this.errorMessages.push('Something went wrong. Please try again later.')
            }
        }
    }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue